import Component from '../core/Component'
import EventBus from '../core/EventBus'

export default class ModalOpener extends Component {

    prepare() {
        this.element.addEventListener('click', :: this.handleClick);
    }

    handleClick(event) {
        event.preventDefault()

        let id = this.element.dataset.modalId || this.element.getAttribute('href')

        if (!id) {
            return;
        }

        id = id.replace('#', '')

        const isModalTerms = id == 'terms'

        if (isModalTerms) {
            const termsInfoBox = document.querySelector('#TermsInfo')
            const termsClose = document.querySelector('.TermsInfo-close')
            const parentBox = termsInfoBox.closest('.FormItem')

            termsInfoBox.classList.toggle('is-active')

            if (parentBox.classList.contains('is-active')) {
                parentBox.classList.remove('is-active')
            } else {
                parentBox.classList.add('is-active')
            }
            termsClose.addEventListener('click', this.handleClose)
        } else {
            const modal = Component.getFromElement(id)

            if (modal) {
                modal.open()
                EventBus.emit('modalopener', {
                    id: id,
                    element: this.element
                })
            }
        }
    }

    handleClose(event) {
        const termsInfoBox = document.querySelector('#TermsInfo')
        const parentBox = termsInfoBox.closest('.FormItem')

        termsInfoBox.classList.remove('is-active')
        parentBox.classList.remove('is-active')
    }

}
